import React, {useMemo} from 'react';

import {buildConfig, withFbProvider} from '@featbit/react-native-sdk';

import {FeatureFlags} from '@medad-sep/core';

import {buildFeatBitOptions} from '../../config/env/featbit';

type FeatBitProviderProps = {
  featureFlags?: FeatureFlags;
  children: React.ReactNode;
};

type BaseProviderProps = {
  children?: React.ReactNode;
};

const BaseProvider = ({children}: BaseProviderProps) => <>{children}</>;

export const FeatBitProvider = ({featureFlags, children}: FeatBitProviderProps) => {
  const options = useMemo(() => buildFeatBitOptions(featureFlags), [featureFlags]);

  const Provider = useMemo(() => {
    if (!options) {
      return BaseProvider;
    }

    return withFbProvider(
      buildConfig({
        options,
      }),
    )(BaseProvider);
  }, [options]);

  return <Provider>{children}</Provider>;
};
